import React from 'react'
import { Box, Chip } from '@mui/material'
import { RolesInfoSectionType } from './type'

const ROLES_LIMIT = 3
const RolesInfoSection: React.FC<RolesInfoSectionType> = ({ roles = [] }) => {
  const rolesToShow = roles.slice(0, ROLES_LIMIT)
  const exceededCount = roles.length - ROLES_LIMIT
  return (
    <Box sx={{ my: 1.5, px: 2.5, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {rolesToShow.map(({ name, id }) => (
        <Chip color='primary' key={id} label={name} variant='outlined' size='small' />
      ))}
      {exceededCount > 0 && (
        <Chip
          key={'exceeded_roles'}
          color='primary'
          label={`+ ${exceededCount} more`}
          variant='outlined'
          size='small'
        />
      )}
    </Box>
  )
}

export default RolesInfoSection
